import Hogan from 'hogan.js';

;(function( $, window, document, undefined ){

  var MarkdownElement = function( elem, options ){
    this.elem = elem;
    this.$elem = $(elem);
    this.options = options;
  };

  // the plugin prototype
  MarkdownElement.prototype = {
    defaults: {
      message: 'Markdown Enabled'
    },

    init: function() {
      this.config = $.extend({}, this.defaults, this.options,
      this.metadata);

      this.processTemplates();

      return this;
    },

    processTemplates: function() {
      var username = $('#account .name').data('username');
      // parse any .markdown-html to inject the username from the header data element
      // into the template and display
      $('.markdown-html', this.$elem).each(function() {
        // markdown is going to parse {{content}} as %7B%7Bcontent%7D%7D. We need to fix that.
        var html = $(this).html().replace(/\%7B%7B(.+?)\%7D%7D/g, "{{$1}}");
        var template = Hogan.compile(html);
        $(this).html(template.render({username: username }));
      });
    }

  };


  MarkdownElement.defaults = MarkdownElement.prototype.defaults;

  $.fn.markdownElement = function(options) {
    return this.each(function() {
      new MarkdownElement(this, options).init();
    });
  };

})( jQuery, window , document );
